"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-ach-out.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-ach-out.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.achOutPaymentContextReturnReasonToJSON = exports.achOutPaymentContextReturnReasonFromJSON = exports.AchOutPaymentContextReversal = exports.AchOutPaymentContext = exports.AchOutPaymentContextReturnReason = void 0;
const ach_account_1 = require("../common/ach-account");
const amount_1 = require("../common/amount");
const external_bank_1 = require("../common/external-bank");
const protobufPackage = 'com.step.common.proto';
/**
 * Common reasons why a transaction was returned.
 */
var AchOutPaymentContextReturnReason;
(function (AchOutPaymentContextReturnReason) {
    AchOutPaymentContextReturnReason["INVALID_RETURN_REASON"] = "INVALID_RETURN_REASON";
    AchOutPaymentContextReturnReason["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    AchOutPaymentContextReturnReason["UNAUTHORIZED"] = "UNAUTHORIZED";
    AchOutPaymentContextReturnReason["CLOSED_ACCOUNT"] = "CLOSED_ACCOUNT";
    AchOutPaymentContextReturnReason["UNAUTHORIZED_DEBIT_ENTRY"] = "UNAUTHORIZED_DEBIT_ENTRY";
    AchOutPaymentContextReturnReason["AUTHORIZATION_REVOKED_BY_USER"] = "AUTHORIZATION_REVOKED_BY_USER";
    AchOutPaymentContextReturnReason["CORPORATE_UNAUTHORIZED"] = "CORPORATE_UNAUTHORIZED";
    AchOutPaymentContextReturnReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AchOutPaymentContextReturnReason || (exports.AchOutPaymentContextReturnReason = AchOutPaymentContextReturnReason = {}));
function createBaseAchOutPaymentContext() {
    return {
        bank: undefined,
        bankStatus: external_bank_1.ExternalBankStatus.INVALID_STATUS,
        accountName: '',
        maskedAccountNumber: '',
        counterpartyName: '',
        checkSerialNumber: '',
        accountType: ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE,
        accountBalance: undefined,
        bankName: '',
        bankLogo: '',
        reversal: undefined,
        fee: undefined,
        isAutoReload: false,
        isRecurring: false,
    };
}
exports.AchOutPaymentContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.bank)) {
            message.bank = external_bank_1.BankDescriptor.fromJSON(object.bank);
        }
        if (isSet(object.bankStatus)) {
            message.bankStatus = (0, external_bank_1.externalBankStatusFromJSON)(object.bankStatus);
        }
        if (isSet(object.accountName)) {
            message.accountName = globalThis.String(object.accountName);
        }
        if (isSet(object.maskedAccountNumber)) {
            message.maskedAccountNumber = globalThis.String(object.maskedAccountNumber);
        }
        if (isSet(object.counterpartyName)) {
            message.counterpartyName = globalThis.String(object.counterpartyName);
        }
        if (isSet(object.checkSerialNumber)) {
            message.checkSerialNumber = globalThis.String(object.checkSerialNumber);
        }
        if (isSet(object.accountType)) {
            message.accountType = (0, ach_account_1.achAccountTypeFromJSON)(object.accountType);
        }
        if (isSet(object.accountBalance)) {
            message.accountBalance = amount_1.Amount.fromJSON(object.accountBalance);
        }
        if (isSet(object.bankName)) {
            message.bankName = globalThis.String(object.bankName);
        }
        if (isSet(object.bankLogo)) {
            message.bankLogo = globalThis.String(object.bankLogo);
        }
        if (isSet(object.reversal)) {
            message.reversal = exports.AchOutPaymentContextReversal.fromJSON(object.reversal);
        }
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        if (isSet(object.isAutoReload)) {
            message.isAutoReload = globalThis.Boolean(object.isAutoReload);
        }
        if (isSet(object.isRecurring)) {
            message.isRecurring = globalThis.Boolean(object.isRecurring);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bank !== undefined) {
            obj.bank = external_bank_1.BankDescriptor.toJSON(message.bank);
        }
        if (message.bankStatus !== undefined && message.bankStatus !== external_bank_1.ExternalBankStatus.INVALID_STATUS) {
            obj.bankStatus = (0, external_bank_1.externalBankStatusToJSON)(message.bankStatus);
        }
        if (message.accountName !== undefined && message.accountName !== '') {
            obj.accountName = message.accountName;
        }
        if (message.maskedAccountNumber !== undefined && message.maskedAccountNumber !== '') {
            obj.maskedAccountNumber = message.maskedAccountNumber;
        }
        if (message.counterpartyName !== undefined && message.counterpartyName !== '') {
            obj.counterpartyName = message.counterpartyName;
        }
        if (message.checkSerialNumber !== undefined && message.checkSerialNumber !== '') {
            obj.checkSerialNumber = message.checkSerialNumber;
        }
        if (message.accountType !== undefined &&
            message.accountType !== ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE) {
            obj.accountType = (0, ach_account_1.achAccountTypeToJSON)(message.accountType);
        }
        if (message.accountBalance !== undefined) {
            obj.accountBalance = amount_1.Amount.toJSON(message.accountBalance);
        }
        if (message.bankName !== undefined && message.bankName !== '') {
            obj.bankName = message.bankName;
        }
        if (message.bankLogo !== undefined && message.bankLogo !== '') {
            obj.bankLogo = message.bankLogo;
        }
        if (message.reversal !== undefined) {
            obj.reversal = exports.AchOutPaymentContextReversal.toJSON(message.reversal);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        if (message.isAutoReload !== undefined && message.isAutoReload !== false) {
            obj.isAutoReload = message.isAutoReload;
        }
        if (message.isRecurring !== undefined && message.isRecurring !== false) {
            obj.isRecurring = message.isRecurring;
        }
        return obj;
    },
    create(base) {
        return exports.AchOutPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutPaymentContext();
        message.bank = (object.bank !== undefined && object.bank !== null)
            ? external_bank_1.BankDescriptor.fromPartial(object.bank)
            : undefined;
        message.bankStatus = object.bankStatus ?? external_bank_1.ExternalBankStatus.INVALID_STATUS;
        message.accountName = object.accountName ?? '';
        message.maskedAccountNumber = object.maskedAccountNumber ?? '';
        message.counterpartyName = object.counterpartyName ?? '';
        message.checkSerialNumber = object.checkSerialNumber ?? '';
        message.accountType = object.accountType ?? ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE;
        message.accountBalance = (object.accountBalance !== undefined && object.accountBalance !== null)
            ? amount_1.Amount.fromPartial(object.accountBalance)
            : undefined;
        message.bankName = object.bankName ?? '';
        message.bankLogo = object.bankLogo ?? '';
        message.reversal = (object.reversal !== undefined && object.reversal !== null)
            ? exports.AchOutPaymentContextReversal.fromPartial(object.reversal)
            : undefined;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        message.isAutoReload = object.isAutoReload ?? false;
        message.isRecurring = object.isRecurring ?? false;
        return message;
    },
};
function createBaseAchOutPaymentContextReversal() {
    return { afterCommitted: false, reason: AchOutPaymentContextReturnReason.INVALID_RETURN_REASON };
}
exports.AchOutPaymentContextReversal = {
    fromJSON(object) {
        const message = {
            afterCommitted: isSet(object.afterCommitted)
                ? globalThis.Boolean(object.afterCommitted)
                : false,
        };
        if (isSet(object.reason)) {
            message.reason = achOutPaymentContextReturnReasonFromJSON(object.reason);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.afterCommitted !== false) {
            obj.afterCommitted = message.afterCommitted;
        }
        if (message.reason !== undefined &&
            message.reason !== AchOutPaymentContextReturnReason.INVALID_RETURN_REASON) {
            obj.reason = achOutPaymentContextReturnReasonToJSON(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.AchOutPaymentContextReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutPaymentContextReversal();
        message.afterCommitted = object.afterCommitted ?? false;
        message.reason = object.reason ?? AchOutPaymentContextReturnReason.INVALID_RETURN_REASON;
        return message;
    },
};
function achOutPaymentContextReturnReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_RETURN_REASON':
            return AchOutPaymentContextReturnReason.INVALID_RETURN_REASON;
        case 1:
        case 'INSUFFICIENT_FUNDS':
            return AchOutPaymentContextReturnReason.INSUFFICIENT_FUNDS;
        case 2:
        case 'UNAUTHORIZED':
            return AchOutPaymentContextReturnReason.UNAUTHORIZED;
        case 3:
        case 'CLOSED_ACCOUNT':
            return AchOutPaymentContextReturnReason.CLOSED_ACCOUNT;
        case 4:
        case 'UNAUTHORIZED_DEBIT_ENTRY':
            return AchOutPaymentContextReturnReason.UNAUTHORIZED_DEBIT_ENTRY;
        case 5:
        case 'AUTHORIZATION_REVOKED_BY_USER':
            return AchOutPaymentContextReturnReason.AUTHORIZATION_REVOKED_BY_USER;
        case 6:
        case 'CORPORATE_UNAUTHORIZED':
            return AchOutPaymentContextReturnReason.CORPORATE_UNAUTHORIZED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AchOutPaymentContextReturnReason.UNRECOGNIZED;
    }
}
exports.achOutPaymentContextReturnReasonFromJSON = achOutPaymentContextReturnReasonFromJSON;
function achOutPaymentContextReturnReasonToJSON(object) {
    switch (object) {
        case AchOutPaymentContextReturnReason.INVALID_RETURN_REASON:
            return 'INVALID_RETURN_REASON';
        case AchOutPaymentContextReturnReason.INSUFFICIENT_FUNDS:
            return 'INSUFFICIENT_FUNDS';
        case AchOutPaymentContextReturnReason.UNAUTHORIZED:
            return 'UNAUTHORIZED';
        case AchOutPaymentContextReturnReason.CLOSED_ACCOUNT:
            return 'CLOSED_ACCOUNT';
        case AchOutPaymentContextReturnReason.UNAUTHORIZED_DEBIT_ENTRY:
            return 'UNAUTHORIZED_DEBIT_ENTRY';
        case AchOutPaymentContextReturnReason.AUTHORIZATION_REVOKED_BY_USER:
            return 'AUTHORIZATION_REVOKED_BY_USER';
        case AchOutPaymentContextReturnReason.CORPORATE_UNAUTHORIZED:
            return 'CORPORATE_UNAUTHORIZED';
        case AchOutPaymentContextReturnReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.achOutPaymentContextReturnReasonToJSON = achOutPaymentContextReturnReasonToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-ach-out.js.map